import { inject, Injectable } from '@angular/core';
import { GlobalConfigurationService } from './global-configuration.service';

@Injectable({
    providedIn: 'root'
})
export class CaddieChatConfigurationService {
    private readonly globalConfigurationService = inject(GlobalConfigurationService);

    readonly url = this.globalConfigurationService.getKey('CaddieChat__IFrameUrl').trim();
    readonly enabled = this.globalConfigurationService.getKey('CaddieChat__Enabled').trim().toLowerCase() === 'true';
    readonly available = this.enabled && Boolean(this.url);
}
